module.exports = __webpack_public_path__ + "static/media/logo200.3b81a9c2.png";